import { useState } from 'react'
import { Grid } from '@material-ui/core'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'
import TMovimientos from '../TMovimientos'
import TCortes from '../TCorte'
const VCorte = () => {
    const [tipo, setTipo] = useState(true)
    const handleClick = () => {
        setTipo(!tipo)
    }
    return (
        <div style={{marginTop: "2%"}}>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10px" }}>
                        <ButtonGroup disableElevation variant="contained" color="primary">
                            <Button onClick={handleClick} color={tipo ? 'primary' : 'default'} >Movimientos</Button>
                            <Button onClick={handleClick} color={!tipo ? 'primary' : 'default'} >Cortes</Button>
                        </ButtonGroup>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    {
                        (tipo) &&
                        <TMovimientos />
                    }

                    {
                        (!tipo) &&
                        <TCortes />
                    }
                </Grid>
            </Grid>
        </div>
    )
}
export default VCorte